// M14: 求積法 - Mensuration
// 系統化數據結構，準備 Supabase 後端遷移

export const M14_MODULE_INFO = {
  moduleId: 'M14',
  title: '求積法',
  titleEn: 'Mensuration',
  description: '學習各種圖形的面積和體積計算',
  totalTopics: 6,
  estimatedTime: '8-10小時',
  difficulty: 'basic',
  prerequisites: ['M04', 'M13'],
  learningObjectives: [
    '掌握平面圖形面積計算',
    '理解立體圖形體積公式',
    '計算表面積',
    '解決複合圖形問題',
    '應用於實際問題'
  ]
};

export const M14_TOPICS = [
  {
    id: 'M14_01',
    name: "基本平面圖形面積",
    description: "基本平面圖形的面積計算",
    order: 1,
    subTopics: [
      "矩形和平行四邊形面積",
      "三角形面積公式",
      "梯形面積計算",
      "菱形面積公式",
      "不規則四邊形面積"
    ]
  },
  {
    id: 'M14_02',
    name: "圓和扇形面積",
    description: "圓形相關圖形的面積計算",
    order: 2,
    subTopics: [
      "圓的面積公式",
      "扇形面積計算",
      "弓形面積計算",
      "環形面積計算",
      "複合圓形圖形"
    ]
  },
  {
    id: 'M14_03',
    name: "基本立體圖形體積",
    description: "基本三維圖形的體積計算",
    order: 3,
    subTopics: [
      "長方體和正方體體積",
      "柱體體積公式",
      "錐體體積公式",
      "球體體積公式",
      "複合立體圖形"
    ]
  },
  {
    id: 'M14_04',
    name: "表面積計算",
    description: "立體圖形的表面積計算",
    order: 4,
    subTopics: [
      "長方體表面積",
      "柱體表面積",
      "錐體表面積",
      "球體表面積",
      "複合圖形表面積"
    ]
  },
  {
    id: 'M14_05',
    name: "複合圖形",
    description: "複雜圖形的面積和體積計算",
    order: 5,
    subTopics: [
      "平面複合圖形",
      "立體複合圖形",
      "切割和組合圖形",
      "相交圖形處理",
      "實際物體建模"
    ]
  },
  {
    id: 'M14_06',
    name: "應用問題",
    description: "求積法在實際問題中的應用",
    order: 6,
    subTopics: [
      "建築面積計算",
      "材料用量估算",
      "容量和裝載問題",
      "土方工程計算",
      "幾何優化問題"
    ]
  }
];

// 導出模組統計信息
export const M14_STATS = {
  totalTopics: M14_TOPICS.length,
  totalSubTopics: M14_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 10,
  difficultyLevel: 1, // 1-3 scale
  prerequisiteModules: 2
}; 